import { AxiosInstance } from 'axios';

/**
 * Axios request interceptor that adds `prefix` to the beginning of the path portion of each request URL.
 */
const withPathPrefix = (prefix: string) => (axios: AxiosInstance) => {
  axios.interceptors.request.use(requestConfig => {
    const requestUrl = requestConfig.url ?? '';
    const prefixedUrl = requestUrl.startsWith(`${prefix}/`)
      ? requestUrl
      : prefix + requestUrl;

    return {
      ...requestConfig,
      url: prefixedUrl,
    };
  });

  return axios;
};

export default withPathPrefix;
